import React from 'react';
import { useNavigate } from 'react-router-dom';
import './About.css';

function About() {
  const navigate = useNavigate();

  return (
    <div className="about-page">
      <div className="about-hero">
        <h1>Our Story</h1>
        <p>Why we built Yardray</p>
      </div>

      <div className="about-content">
        <div className="about-card">

          <p className="about-body-text">
            A few years ago, we moved into a new house with the most beautiful yard we had ever seen. The previous owners clearly lived outside — gorgeous hydrangeas, flowering trees, bushes we couldn't name, and beds full of plants we had never dealt with before. Stunning. And we had absolutely no idea what to do with any of it.
          </p>

          <p className="about-body-text">
            We're not professional gardeners. We have weekends. Every time we walked outside we had more questions than answers. After the hydrangeas bloomed and started looking rough, we stood there thinking: do we cut these back or leave them alone? We had to stop what we were doing, go inside, open a browser, and dig through a dozen articles just to get a straight answer. And then try to remember what we'd found out by next season.
          </p>

          <p className="about-body-text">
            We wanted one place where we could point a phone at a plant, find out what it is, and get real answers — when does it bloom, does it come back every year, when do we prune it, what else can we plant next to it?
          </p>

          <p className="about-body-text">
            Then came the lawn. The yard wasn't in great shape when we moved in, so we hired a lawn service. They fertilized, treated for crabgrass, put down weed control, spread grass seed. Fine. But then they kept pushing us to aerate — we'd already done it the year before and honestly the yard looked worse afterward. We said no. But it got us wondering: what exactly are they putting on our lawn, how much does it cost if we buy it ourselves, and could we just do this on our own?
          </p>

          <p className="about-body-text">
            That question turned into a whole other thing. We started tracking what was applied, when, and with what product. We wanted to know if it was working, what to keep doing, and what to skip.
          </p>

          <p className="about-body-text about-body-text--last">
            Yardray is what we built to solve all of this. It's not for professional gardeners. It's for people who inherited a beautiful yard, want to take care of it, and just need a straight answer without spending an hour researching before they can pick up a shovel.
          </p>

          <div className="about-footer">
            <button
              onClick={() => navigate('/')}
              className="about-back-btn"
            >
              Back to Yardray
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
